<template>
  <v-layout
    row
    wrap
    align-center
  >
    <div style="width:118px">
      <v-select
        v-model="selectedCountry"
        style="margin-top:0"
        :items="countries"
        return-object
        :disabled="disabled"
      >
        <template
          v-slot:selection="{ item }"
        >
          <span>
            <img
              width="32"
              height="32"
              :src="`./flags/${item.ISO2}.png`"
            >
          </span>
          <span class="pl-2">+ {{ item.diallingCode }}</span>
        </template>
        <template v-slot:item="{ item }">
          <v-container
            grid-list-lg
            fluid
            class="pa-0"
          >
            <v-layout
              row
              wrap
              justify-start
              align-center
            >
              <v-flex xs2>
                <v-img
                  :src="`./flags/${item.ISO2}.png`"
                  width="40"
                  height="40"
                />
              </v-flex>
              <v-flex xs10>
                <span class="black--text"> {{ item.name }} ({{ item.diallingCode }})</span>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
        <!-- TODO: For some reason selected country is not highlighted with primary color-->
      </v-select>
    </div>
    <template v-if="required">
      <v-text-field
        v-model="number"
        :rules="[
          (v) => {return validateNumber(v, selectedCountry.ISO2);}
        ]"
        class="ml-2"
        name="name"
        :loading="loading"
        :label="label"
        type="number"
        :disabled="disabled"
      />
    </template>
    <template v-else>
      <v-text-field
        v-model="number"
        :rules="[
          (v) => {return checkValidity(v, selectedCountry.ISO2);}
        ]"
        class="ml-2"
        name="name"
        :label="label"
        :loading="loading"
        type="number"
        :disabled="disabled"
      />
    </template>
  </v-layout>
</template>
<script>
import axios from 'axios';
import {
  isValidNumber,
  formatNumber,
  parseNumber,
  parsePhoneNumberFromString
} from 'libphonenumber-js';

export default {
  name: 'PhoneField',
  model: {
    prop: 'inputNumber',
    event: 'change'
  },
  props: {
    inputNumber: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultCountryCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      countries: [],
      selectedCountry: {},
      number: ''
    };
  },
  watch: {
    inputNumber: {
      handler(val) {
        if (!val || this.countries.length === 0) return;
        const phone = parsePhoneNumberFromString(val, this.defaultCountryCode);
        this.number = phone.nationalNumber;
        this.selectedCountry = this.countries.filter(
          country => country.ISO2 === phone.country
        )[0];
      },
      immediate: true
    },
    number: {
      handler(val) {
        if (!val) return;
        const validity = isValidNumber(val, this.selectedCountry.ISO2);
        if (validity) {
          const parsed = parseNumber(val, this.selectedCountry.ISO2);
          const formattedNumber = formatNumber(parsed, 'E.164');
          this.$emit('change', formattedNumber);
        }
      }
    }
  },
  created() {
    axios.get('/countries.json').then(response => {
      const countriesArray = response.data;
      this.selectedCountry = countriesArray.filter(
        country => country.ISO2 === this.defaultCountryCode
      )[0];
      this.countries = countriesArray;
      const phone = parsePhoneNumberFromString(
        this.inputNumber,
        this.defaultCountryCode
      );
      if (!phone) return;
      this.number = phone.nationalNumber;
      this.selectedCountry = this.countries.filter(
        country => country.ISO2 === phone.country
      )[0];
    });
  },
  methods: {
    validateNumber(value, code) {
      if (value) {
        const validity = isValidNumber(value, code);
        if (validity) return true;
        return 'Phone number is not valid';
      }
      return 'Phone number is required';
    },
    checkValidity(value, code) {
      const validity = isValidNumber(value, code);
      if (validity) return true;
      return 'Phone number is not valid';
    }
  }
};
</script>

